<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap v-if="browserNotSupported">
            <v-card>
                <v-card-title>{{__('dialogs.browser_not_supported_title')}}</v-card-title>
                <v-card-text>{{__('dialogs.browser_not_supported_text')}}</v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat href="https://www.google.com/intl/en_ALL/chrome/" target="_blank">{{__('dialogs.browser_not_supported_chrome')}}</v-btn>
                    <v-btn flat href="https://www.mozilla.org/en-US/firefox/" target="_blank">{{__('dialogs.browser_not_supported_firefox')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-layout>
        <v-layout row wrap v-else>
            <intro-dialog v-model="introDialog"></intro-dialog>
            <repeat-dialog v-model="repeatDialog" @ok="repeatForm" @cancel="deleteCookies(); repeatDialog=false;"></repeat-dialog>
            <continue-dialog v-model="continueDialog" @ok="continueForm" @cancel="deleteCookies(); continueDialog=false;"></continue-dialog>
            <contact-dialog :disabled="disabled" :company="company"></contact-dialog>
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on }">
              <v-btn flat v-on="on" absolute top left class="mt-5">{{locale==='en' ? 'English' : 'Deutsch'}} <v-icon right>keyboard_arrow_down</v-icon></v-btn>
            </template>
            <v-list>
              <v-list-tile @click="goGerman">
                <v-list-tile-title>Deutsch</v-list-tile-title>
              </v-list-tile>
            <v-list-tile @click="goEnglish">
              <v-list-tile-title>English</v-list-tile-title>
            </v-list-tile>
            </v-list>
          </v-menu>
            <failure-snackbar v-model="error">{{errorMsg}}</failure-snackbar>
            <v-flex xs12 lg10 xl8 offset-lg1 offset-xl2>
                <v-stepper v-model="currentStep" alt-labels class="elevation-0" style="background:transparent">
                    <v-stepper-header class="elevation-0">
                        <v-stepper-step :complete="currentStep > 1" :step="1" :editable="!disabled && currentStep > 1"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.address')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 2" :step="2" :editable="!disabled && currentStep > 2"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.event')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 3" :step="3" :editable="!disabled && currentStep > 3"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.invoice')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 4" :step="4" :editable="!disabled && currentStep > 4"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.bank_account')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 5" :step="5" :editable="!disabled && currentStep > 5"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.taxes')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 6" :step="6" :editable="!disabled && currentStep > 6"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.royalty')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 7" :step="7" :editable="!disabled && currentStep > 7"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.traveling_expense')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 8" :step="8" :editable="!disabled && currentStep > 8"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.sum')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 9" :step="9" :editable="!disabled && currentStep > 9"
                                        :edit-icon="$vuetify.icons.complete">
                            {{__('labels.upload')}}
                        </v-stepper-step>
                        <v-divider></v-divider>
                        <v-stepper-step :complete="currentStep > 10" :step="10"
                                        :editable="!disabled && currentStep > 10" :edit-icon="$vuetify.icons.complete">
                            {{__('labels.summary')}}
                        </v-stepper-step>
                    </v-stepper-header>
                </v-stepper>
                <v-stepper v-model="currentStep">
                    <v-stepper-items>
                        <v-stepper-content :step="1">
                            <address-step></address-step>
                        </v-stepper-content>
                        <v-stepper-content :step="2">
                            <event-step></event-step>
                        </v-stepper-content>
                        <v-stepper-content :step="3">
                            <invoice-step></invoice-step>
                        </v-stepper-content>
                        <v-stepper-content :step="4">
                            <bank-account-step></bank-account-step>
                        </v-stepper-content>
                        <v-stepper-content :step="5">
                            <tax-step></tax-step>
                        </v-stepper-content>
                        <v-stepper-content :step="6">
                            <royalty-step></royalty-step>
                        </v-stepper-content>
                        <v-stepper-content :step="7">
                            <traveling-expenses-step></traveling-expenses-step>
                        </v-stepper-content>
                        <v-stepper-content :step="8">
                            <sum-step></sum-step>
                        </v-stepper-content>
                        <v-stepper-content :step="9">
                            <upload-step></upload-step>
                        </v-stepper-content>
                        <v-stepper-content :step="10">
                            <summary-step></summary-step>
                        </v-stepper-content>
                    </v-stepper-items>
                </v-stepper>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'

    export default {
        name: "Stepper",
        props: {
            events: Array,
            countries: Array,
            company: Object
        },
        data() {
            return {
                repeatDialog: false,
                continueDialog: false,
                introDialog: true,
                browserNotSupported: navigator.userAgent.indexOf("MSIE") >= 0,
            }
        },
        methods: {
          goGerman() {
            window.location.href=(window.location.protocol ==='https' ? 'https' : 'http') +'://' + window.location.hostname + window.location.pathname.replace('/en', '')
          },
          goEnglish() {
            window.location.href=(window.location.protocol ==='https' ? 'https' : 'http') +'://' + window.location.hostname +'/en' + window.location.pathname.replace('/en', '')
          },
            countryChanged($country) {
                if (($country === 'DE' && (this.taxes !== '0' || this.taxes !== '19')) || ($country !== 'DE' && (this.taxes !== 'reverse'))) {
                    this.taxes = '';
                }
                this.address = Object.assign({}, this.address);
            },
            setCookieData() {
                let completed = this.$cookies.get('completed');
                if(this.step > 1 && !completed) {
                    this.$cookies.set('step', this.step);
                    this.$cookies.set('cancelled', true);
                }
            },
            initFromCookie() {
                let cancelled = this.$cookies.get('cancelled');
                let completed = this.$cookies.get('completed');
                if(cancelled) {
                    this.continueDialog = true;
                    this.introDialog =false;
                } else if(completed) {
                    this.repeatDialog = true;
                    this.introDialog =false;
                }
            },
            continueForm() {
                this.$store.dispatch('stepper/initFromCookie');
                this.$store.dispatch('form/initFromCookie');
                this.continueDialog=false;
            },
            repeatForm() {
                this.$store.dispatch('form/initFromCookie');
                this.$cookies.remove('completed');
                this.repeatDialog=false;
            },
            deleteCookies() {
                this.$cookies.remove('cancelled');
                this.$cookies.remove('completed');
                this.$cookies.remove('step');
                this.$cookies.remove('address');
                this.$cookies.remove('event');
                this.$cookies.remove('performanceDates');
                this.$cookies.remove('invoice');
                this.$cookies.remove('bankAccount');
                this.$cookies.remove('taxes');
                this.$cookies.remove('royalties');
                this.$cookies.remove('travelingExpenses');
                this.$cookies.remove('miscTravelingExpenses');
            }
        },
        created: function () {
            this.$store.registerModule('stepper', {
                namespaced: true,
                state: {
                    step: 1,
                    tmpStep: 0,
                    previewLoading: false,
                    submitLoading: false,

                },
                mutations: {
                    setStep(state, payload) {
                        if(payload !== state.step) {
                            if (payload < state.step - 1) {
                                state.tmpStep = state.step;
                            } else {
                                state.tmpStep = 0;
                            }
                            state.step = payload;
                        }
                    },
                    previousStep(state) {
                        state.step--;
                        state.tmpStep = 0;
                    },
                    nextStep(state) {
                        if (state.tmpStep) {
                            state.step = state.tmpStep;
                            state.tmpStep = 0;
                        } else {
                            state.step++;
                        }
                    },
                    setPreviewLoading(state, payload) {
                        state.previewLoading = payload;
                    },
                    setSubmitLoading(state, payload) {
                        state.submitLoading = payload;
                    },
                },
                getters: {
                    disabled(state) {
                        return state.previewLoading || state.submitLoading;
                    },
                    locale() {
                      return window.location.pathname.startsWith('/en') ? 'en' : 'de'
                    }
                },
                actions: {
                    initFromCookie({commit}) {
                        let step = $cookies.get('step');
                        if(step) {
                            step = Math.min(step, 8);
                            commit('setStep', step);
                        }
                    },
                }
            });

            this.$store.registerModule('form', {
                namespaced: true,
                state: {
                    address: {
                        email: '',
                        repeatEmail: '',
                        company: '',
                        salutation: '',
                        title: '',
                        first_name: '',
                        last_name: '',
                        street: '',
                        street_suffix: '',
                        zip: '',
                        city: '',
                        country_code: 'DE',
                        phone: '',
                    },
                    event: 0,
                    performanceDates: [{name:'', dates:[]}],
                    invoice: {invoice_number: '', invoice_date: this.$moment().format('YYYY-MM-DD'), tax_id: '',},
                    bankAccount: {iban: '', swift: '', owner: ''},
                    taxes: '',
                    royalties: null,
                    travelingExpenses: {
                        train: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.train')},
                        plane: {netto: null, brutto: null, taxes: 19, name: this.__('invoices.plane')},
                        car: {km: null, netto: null, brutto: null, name: this.__('invoices.car')},
                        bus: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.bus')},
                        taxi: {netto: null, brutto: null, taxes: 7, name: this.__('invoices.taxi')},
                        parking: {netto: null, brutto: null, taxes: 19, name: this.__('invoices.parking')},
                    },
                    miscTravelingExpenses: [],
                    expensesSum: null,
                    receipts: {receiptsNew: []},
                    countries: this.sortedCountries,
                    events: this.events,
                    error: false,
                    errorMsg: false,
                },
                mutations: {
                    setAddress(state, payload) {
                        state.address = payload;
                    },
                    setEvent(state, payload) {
                        state.event = payload;
                    },
                    setLocations(state, payload) {
                        state.locations = payload;
                    },
                    setInvoice(state, payload) {
                        state.invoice = payload;
                    },
                    setBankAccount(state, payload) {
                        state.bankAccount = payload;
                    },
                    setTaxes(state, payload) {
                        state.taxes = payload;
                    },
                    setRoyalties(state, payload) {
                        state.royalties = payload;
                    },
                    setTravelingExpenses(state, payload) {
                        state.travelingExpenses = payload;
                    },
                    setMiscTravelingExpenses(state, payload) {
                        state.miscTravelingExpenses = payload;
                    },
                    addMiscTravelingExpense(state) {
                        state.miscTravelingExpenses.push({description: '', taxes: '', netto: null, brutto: null});
                    },
                    removeMiscTravelingExpense(state, payload) {
                        Vue.delete(state.miscTravelingExpenses, payload);
                    },
                    addPerformanceDate(state) {
                        state.performanceDates.push({name:'',dates:[]});
                    },
                    setPerformanceDates(state, payload) {
                        state.performanceDates = payload;
                    },
                    removePerformanceDate(state, payload) {
                        Vue.delete(state.performanceDates, payload);
                    },
                    setExpensesSum(state, payload) {
                        state.expensesSum = payload;
                    },
                    setReceipts(state, payload) {
                        state.receipts = payload;
                    },
                    setError(state, error) {
                        state.error = error;
                    },
                    setErrorMsg(state, msg) {
                        state.errorMsg = msg;
                    },
                },
                actions: {
                    initFromCookie({commit}) {
                        let address = $cookies.get('address');
                        let event = parseInt($cookies.get('event'));
                        let performanceDates = JSON.parse($cookies.get('performanceDates'));
                        let invoice = $cookies.get('invoice');
                        let bankAccount = $cookies.get('bankAccount');
                        let taxes = $cookies.get('taxes');
                        let royalties = parseInt($cookies.get('royalties'));
                        let travelingExpenses = $cookies.get('travelingExpenses');
                        let miscTravelingExpenses = JSON.parse($cookies.get('miscTravelingExpenses'));
                        if(address) {
                            commit('setAddress', address);
                        }
                        if(event) {
                            commit('setEvent', event);
                        }
                        if(performanceDates) {
                            commit('setPerformanceDates', performanceDates);
                        }
                        if(invoice) {
                            commit('setInvoice', invoice);
                        }
                        if(bankAccount) {
                            commit('setBankAccount', bankAccount);
                        }
                        if(taxes) {
                            commit('setTaxes', taxes);
                        }
                        if(royalties) {
                            commit('setRoyalties', royalties);
                        }
                        if(travelingExpenses) {
                            commit('setTravelingExpenses', travelingExpenses);
                        }
                        if(miscTravelingExpenses) {
                            commit('setMiscTravelingExpenses', miscTravelingExpenses);
                        }
                    },
                    setError({commit, state}, msg) {
                        commit('setError', true);
                        commit('setErrorMsg', msg);
                    },
                    setEvent({commit, state}, payload) {
                        commit('setEvent', payload);
                        _.each(state.locations, (location) =>{location.selected=false;});
                        state.locations = _.get(_.find(state.events, {id: payload}), 'locations');
                        _.each(state.locations, (location) =>{location.selected=true;});
                    },
                    removeMiscTravelingExpense({state, dispatch, commit}, payload) {
                        commit('removeMiscTravelingExpense', payload);
                        dispatch('calculateSum')
                    },
                    calculateSum({commit, state}) {
                        let key = 'brutto';
                        if(state.taxes === '19') {
                            key = 'netto'
                        }
                        let sumExpenses = _.sumBy(_.values(state.travelingExpenses), function(expense) {
                            let expenseAmount = _.get(expense, key );
                            return expenseAmount ? expenseAmount : 0;
                        });
                        let sumMiscExpenses = _.sumBy(_.values(state.miscTravelingExpenses), function(expense) {
                            let expenseAmount = _.get(expense, key );
                            return expenseAmount ? expenseAmount : 0;
                        });
                        commit('setExpensesSum', sumExpenses + sumMiscExpenses);
                    }
                },
            });
            window.addEventListener("beforeunload", this.setCookieData);
            this.initFromCookie();
        },
        computed: {
            ...mapState('form', [
                'errorMsg',
            ]),
            ...mapState('stepper', [
                'step',
            ]),
            ...mapGetters('stepper', [
                'disabled', 'locale'
            ]),

            error: {
                get() {
                    return this.$store.state.form.error;
                },
                set(v) {
                    this.$store.commit('form/setError', v);
                }
            },
            currentStep: {
                get: function () {
                    return this.$store.state.stepper.step;
                },
                set: function (newValue) {
                    this.$store.commit('stepper/setStep', newValue)
                }
            },
            sortedCountries() {
                let de = _.find(this.countries, {value:'DE'});
                let at = _.find(this.countries, {value:'AT'});
                let ch = _.find(this.countries, {value:'CH'});
                let countries = _.pullAllBy(this.countries, [{value:'DE'}, {value:'AT'}, {value:'CH'}], 'value');
                countries.unshift(de, at, ch, { divider: true });
                return countries;
            }
        },
    }
</script>

<style scoped>

</style>
